import { SavedSearch } from "@/components/job-configuration-dialog"
import { mapToSavedSearches, sortSavedSearchesByDate } from "@/utils/search-utils"
import { useGetSearch } from "openapi/api/endpoints"

export const useGetSavedSearches=()=>{
    const{data}=useGetSearch()

    let mappedData:SavedSearch[]=[]
    if(data){
        mappedData=sortSavedSearchesByDate(mapToSavedSearches(data)).slice(0,3)
    }

    return {savedSearches:mappedData}
}